import * as React from "react";
import { Route, Navigate, Routes } from "react-router-dom";
import useUserTheme from "shared/styles/hooks/useUserTheme";
import { ThemeProvider } from "styled-components";
import { PageLoadSpinner } from "../shared/components/PageLoadSpinner";

import { getEnvironments, setIsLoading } from "./actions/AppActions";
import { initialState, reducer } from "./reducers/AppReducer";
import { IAppReducerState } from "./shared/model";

import EnvironmentList from "./components/EnvironmentList";
import useLegacyAgentsEolToast from "./hooks/useLegacyAgentsEolToast";

export const AppContext = React.createContext<IAppReducerState>({ state: initialState, dispatch: () => null });

const App: React.FC<React.PropsWithChildren<unknown>> = () => {

    const [themeType] = useUserTheme();
    const [state, dispatch] = React.useReducer(reducer, initialState);

    React.useEffect(() => {
        setIsLoading(dispatch, true);
        getEnvironments(dispatch);
        setIsLoading(dispatch, false);
    }, []);

    const hasLegacyAgents = React.useMemo(() =>
        state.environments.some(env => env.agentGroups?.some(g => !g.isCrossPlatform)),
        [state.environments]
    );

    useLegacyAgentsEolToast(hasLegacyAgents);

    return (
        <AppContext.Provider value={{ state, dispatch }}>
            <ThemeProvider theme={{ mode: themeType }}>
                <React.Suspense fallback={<PageLoadSpinner />}>
                    <Routes>
                        <Route path="/" element={
                            <Navigate
                                to="Default/Default"
                                replace
                            />
                        } />
                        <Route path="*" element={
                            <EnvironmentList />
                        } />
                    </Routes>
                    {state.isLoading && <PageLoadSpinner />}
                </React.Suspense>
            </ThemeProvider>
        </AppContext.Provider>
    );
};

export default App;